// extracted by mini-css-extract-plugin
module.exports = {"image":"img-module--image--3UjLV","narrow":"img-module--narrow--8Web8"};